function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { CameraHelper, Color, Vector3 } from 'three';
import Coordinates from "../../src/Core/Geographic/Coordinates";
import { MAIN_LOOP_EVENTS } from "../../src/Core/MainLoop";
import OBB from "../../src/Renderer/OBB";
import * as THREE from 'three';
import ThreeStatsChart from "./charts/ThreeStatsChart";
import { backgroundChartDiv, color_blue } from "./charts/ChartConfig";
import OBBHelper from "./OBBHelper";

/**
 * Create a debug instance attached to an itowns instance
 *
 * @Constructor
 * @param {Scene} scene the itowns Scene
 * @return {Debug} a debug instance
 */

// disabling eslint errors as it is the exported constructor
function Debug(view, datDebugTool, chartDivContainer) {
  var _this = this;
  // CHARTS
  // Create default charts div if missing
  if (!chartDivContainer) {
    chartDivContainer = document.createElement('div');
    chartDivContainer.id = 'chart-div';
    chartDivContainer.style.cssText = "z-index: 10; position: absolute; bottom: 0; left: 0; width: 100vw; height: 30%; background-color: ".concat(backgroundChartDiv, "; display: none");
    document.body.appendChild(chartDivContainer);
  }
  this.chartDivContainer = chartDivContainer;
  var canvas = this.createChartContainer('three-info');
  var ctx = canvas.getContext('2d');
  this.charts = [];
  this.charts.push(new ThreeStatsChart(ctx, view.mainLoop.gfxEngine.renderer));
  var charts = this.charts;
  var tileLayer = view.tileLayer;
  var initialPosition = new Coordinates(view.referenceCrs, 0.0, 0.0, 0.0);
  var geoPosition = new Coordinates('EPSG:4326', 0.0, 0.0, 0.0);
  function debugChartUpdate(updateDuration) {
    var displayed = chartDivContainer.style.display != 'none';
    charts.forEach(function (c) {
      return c.update(displayed, updateDuration);
    });
  }

  // DEBUG CONTROLS
  var gui = datDebugTool.addFolder('Debug Tools');
  var state = {
    displayCharts: false,
    eventsDebug: false,
    debugCameraWindow: false,
    freeze: false
  };
  var before;
  var startChart = function startChart() {
    before = Date.now();
  };
  var endChart = function endChart() {
    var duration = Date.now() - before;
    // debug graphs update
    debugChartUpdate(duration);
  };

  // charts
  gui.add(state, 'displayCharts').name('Display charts').onChange(function (newValue) {
    if (newValue) {
      view.addFrameRequester(MAIN_LOOP_EVENTS.UPDATE_START, startChart);
      view.addFrameRequester(MAIN_LOOP_EVENTS.UPDATE_END, endChart);
      chartDivContainer.style.display = 'flex';
    } else {
      view.removeFrameRequester(MAIN_LOOP_EVENTS.UPDATE_START, startChart);
      view.removeFrameRequester(MAIN_LOOP_EVENTS.UPDATE_END, endChart);
      chartDivContainer.style.display = 'none';
    }
    _this.updateChartDivSize();
    view.notifyChange();
  });
  gui.add(state, 'debugCameraWindow').name('debug Camera').onChange(function (value) {
    if (value) {
      view.addFrameRequester(MAIN_LOOP_EVENTS.AFTER_RENDER, renderCameraDebug);
    } else {
      view.removeFrameRequester(MAIN_LOOP_EVENTS.AFTER_RENDER, renderCameraDebug);
    }
    view.notifyChange();
  });
  gui.add(state, 'freeze').name('freeze update').onChange(function (newValue) {
    tileLayer.frozen = newValue;
    view.notifyChange();
  });

  // camera-target-updated event
  var LatController;
  var LongController;
  var AltiController;
  var eventFolder;
  var controls = view.controls;
  initialPosition.crs = view.referenceCrs;
  var cursorWorldPosition = new THREE.Vector3();
  var getCenter = controls && controls.getCameraTargetPosition ? controls.getCameraTargetPosition : function () {
    return view.camera.camera3D.position;
  };
  var cameraTargetListener = function cameraTargetListener(event) {
    if (view.getPickingPositionFromDepth(view.eventToViewCoords(event), cursorWorldPosition)) {
      initialPosition.setFromVector3(cursorWorldPosition).as('EPSG:4326', geoPosition);
      state.latitude = "".concat(geoPosition.y.toFixed(6));
      state.longitude = "".concat(geoPosition.x.toFixed(6));
      state.altitude = "".concat(geoPosition.z.toFixed(2));
    } else {
      state.latitude = '---------';
      state.longitude = '---------';
      state.altitude = '---------';
    }
    LatController.updateDisplay();
    LongController.updateDisplay();
    AltiController.updateDisplay();
  };
  gui.add(state, 'eventsDebug').name('Debug event').onChange(function () {
    return function (newValue) {
      if (newValue) {
        eventFolder = gui.addFolder('Events');
        eventFolder.open();
        initialPosition.setFromVector3(getCenter()).as('EPSG:4326', geoPosition);
        state.latitude = "".concat(geoPosition.y.toFixed(6));
        state.longitude = "".concat(geoPosition.x.toFixed(6));
        state.altitude = "".concat(geoPosition.z.toFixed(2));
        LatController = eventFolder.add(state, 'latitude');
        LongController = eventFolder.add(state, 'longitude');
        AltiController = eventFolder.add(state, 'altitude');
        view.domElement.addEventListener('mousemove', cameraTargetListener);
      } else {
        view.domElement.removeEventListener('mousemove', cameraTargetListener);
        gui.removeFolder('Events');
      }
    };
  }());

  // Camera debug
  var helper = new CameraHelper(view.camera.camera3D);
  var debugCamera = view.camera.camera3D.clone();
  debugCamera.fov *= 1.5;
  debugCamera.updateProjectionMatrix();
  var g = view.mainLoop.gfxEngine;
  var r = g.renderer;
  var fogDistance = 10e10;
  var layerAtmosphere = view.getLayerById('atmosphere');
  if (layerAtmosphere) {
    fogDistance = layerAtmosphere.fog.distance;
  }
  helper.visible = false;
  view.scene.add(helper);

  // Displayed tiles boundind box
  var displayedTilesObb = new OBB();
  var displayedTilesObbHelper = new OBBHelper(displayedTilesObb, '', new Color(color_blue));
  displayedTilesObbHelper.visible = false;
  view.scene.add(displayedTilesObb);
  view.scene.add(displayedTilesObbHelper);
  function updateFogDistance(obj) {
    if (obj.material && fogDistance) {
      obj.material.fogDistance = fogDistance;
    }
  }
  var clearColor = new Color();
  var lookAtCameraDebug = new Vector3();
  function renderCameraDebug() {
    if (state.debugCameraWindow && debugCamera) {
      var ratio = 0.25;
      var size = {
        x: g.width * ratio,
        y: g.height * ratio
      };
      debugCamera.aspect = size.x / size.y;
      var camera = view.camera.camera3D;
      var coord = new Coordinates(view.referenceCrs, camera.position).as(tileLayer.extent.crs);
      var extent = view.tileLayer.info.displayed.extent;
      displayedTilesObb.setFromExtent(extent);
      displayedTilesObbHelper.visible = true;
      displayedTilesObbHelper.updateMatrixWorld(true);

      // Note Method to compute near and far...
      // const bbox = displayedTilesObb.box3D.clone().applyMatrix4(displayedTilesObb.matrixWorld);
      // const distance = bbox.distanceToPoint(view.camera.camera3D.position);
      // console.log('distance', distance, distance + bbox.getBoundingSphere(sphere).radius * 2);

      // Compute position camera debug
      var altitudeCameraDebug = 1.5 * coord.z;
      coord.z = altitudeCameraDebug;
      coord.as(view.referenceCrs).toVector3(debugCamera.position);
      // Compute recoil camera
      camera.worldToLocal(debugCamera.position);
      debugCamera.position.z += altitudeCameraDebug;
      camera.localToWorld(debugCamera.position);
      // Compute target camera debug
      lookAtCameraDebug.copy(view.camera.camera3D.position);
      camera.worldToLocal(lookAtCameraDebug);
      lookAtCameraDebug.z -= altitudeCameraDebug * 1.5;
      camera.localToWorld(lookAtCameraDebug);
      debugCamera.lookAt(lookAtCameraDebug);
      helper.update();
      debugCamera.updateProjectionMatrix();
      if (layerAtmosphere) {
        layerAtmosphere.object3d.visible = false;
        fogDistance = 10e10;
        var _iterator = _createForOfIteratorHelper(tileLayer.level0Nodes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var obj = _step.value;
            obj.traverseVisible(updateFogDistance);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      var deltaY = state.displayCharts ? Math.round(parseFloat(chartDivContainer.style.height.replace('%', '')) * g.height / 100) + 3 : 0;
      helper.visible = true;
      helper.updateMatrixWorld(true);
      r.getClearColor(clearColor);
      r.setViewport(g.width - size.x, deltaY, size.x, size.y);
      r.setScissor(g.width - size.x, deltaY, size.x, size.y);
      r.setScissorTest(true);
      r.setClearColor(backgroundChartDiv);
      r.clear();
      r.render(view.scene, debugCamera);
      r.setScissorTest(false);
      r.setClearColor(clearColor);
      r.setViewport(0, 0, g.width, g.height);
      helper.visible = false;
      displayedTilesObbHelper.visible = false;
      if (layerAtmosphere) {
        layerAtmosphere.object3d.visible = true;
      }
      if (layerAtmosphere) {
        fogDistance = layerAtmosphere.fog.distance;
        var _iterator2 = _createForOfIteratorHelper(tileLayer.level0Nodes),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _obj = _step2.value;
            _obj.traverseVisible(updateFogDistance);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }
}
Debug.prototype.createChartContainer = function createChartContainer(chartId) {
  var div = document.createElement('div');
  div.style.cssText = "background-color: ".concat(backgroundChartDiv, "; flex: auto;");
  this.chartDivContainer.appendChild(div);
  var chartCanvas = document.createElement('canvas');
  chartCanvas.height = '20rem';
  chartCanvas.id = chartId;
  div.appendChild(chartCanvas);
  return chartCanvas;
};
Debug.prototype.updateChartDivSize = function updateChartDivSize() {
  var count = 0;
  var _iterator3 = _createForOfIteratorHelper(this.chartDivContainer.getElementsByTagName('div')),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var div = _step3.value;
      if (div.style.display !== 'none') {
        count++;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  var size = Math.floor(100 / count);
  var _iterator4 = _createForOfIteratorHelper(this.chartDivContainer.getElementsByTagName('div')),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _div = _step4.value;
      if (_div.style.display !== 'none') {
        _div.style.width = "".concat(size, "%");
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  this.charts.forEach(function (c) {
    c.resize();
    c.update();
  });
};
export default Debug;